export * from '@primeuix/themes/lara/scrollpanel';
export { default } from '@primeuix/themes/lara/scrollpanel';
